/**
 * @generated SignedSource<<bbfb4944da798356dac04b3432d53f48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleVariant_viewer$data = {
  readonly onSaleVerticals: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleItemVariant_onSaleVertical">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarouselVariant_viewer">;
  readonly " $fragmentType": "HpSharedFeaturedModuleVariant_viewer";
};
export type HpSharedFeaturedModuleVariant_viewer$key = {
  readonly " $data"?: HpSharedFeaturedModuleVariant_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleVariant_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleVariant_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedFeaturedModuleCarouselVariant_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OnSaleVertical",
      "kind": "LinkedField",
      "name": "onSaleVerticals",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModuleItemVariant_onSaleVertical"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e7739ce0a911064ea708903f728ec516";

export default node;
